export const PROJECT_NAME = 'territories'
